import { createSharedState } from 'Shared/use-shared-state';

export const modalIsOpenSlice = createSharedState('modelIsOpen');
export const useModalIsOpen = modalIsOpenSlice.hook;
